<template>
    <div>
        <!--<v-title title="基本信息" style="margin-left: -15px">-->
        <!--&lt;!&ndash;<el-button type="primary" size="mini" @click="getDemoPat">生成测试用户</el-button>&ndash;&gt;-->
        <!--</v-title>-->
        <hos_apply_title title="患者基本信息"></hos_apply_title>
        <el-form ref="form" :model="form" class="mt20" label-position="left" :rules="patineInfoRules"
                 :disabled="readonly" size="mini">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="患者就诊卡号" label-width="100px">
                        <el-input v-model="cardId" placeholder="请输入就诊卡号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                    <el-form-item label-width="20px">
                        <el-select v-model="cardIdHos" placeholder="请选择就诊卡号所属医院">
                            <el-option :label="hos.yymc" :value="hos.yyid" v-for="(hos,index) in cardIdHosList"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4" :push="1">
                    <el-form-item>
                        <el-button type="primary" @click="search">检索</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="病人姓名" label-width="80px" prop="patName">
                        <el-input v-model="form.patName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="14" :push="2">
                    <el-form-item label="证件号" label-width="80px" prop="patIdcard">
                        <el-input v-model="form.patIdcard" @blur="mathSexAndAge"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="性别" label-width="40px">
                        <el-select v-model="form.sex">
                            <el-option label="男" value="M"></el-option>
                            <el-option label="女" value="F"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="年龄" label-width="40px">
                        <el-input v-model="form.age"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="13">
                    <el-form-item label="电话" label-width="60px" prop="patMobile">
                        <el-input v-model="form.patMobile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="9">
                    <el-form-item label="职业" label-width="40px" prop="patJob">
                        <el-input v-model="form.patJob"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="13" :push="2">
                    <el-form-item label="其他联系方式" label-width="100px">
                        <el-input v-model="form.otherContactWay"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-form-item label="家庭地址" label-width="80px" prop="province">
                        <el-select v-model="form.province" placeholder="请选择省" @change="getCityList('1')">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in provinceList"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item prop="city">
                        <el-select v-model="form.city" placeholder="请选择市" @change="getCityList('2')">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in cityList"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item prop="areaCode">
                        <el-select v-model="form.area" placeholder="请选择区">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in areaList"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="80px" prop="address">
                        <el-input v-model="form.address" placeholder="街道等 详细地址 选择填写"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--<el-row :gutter="20">-->
            <!--<el-col :span="4">-->
            <!--<el-form-item label="转诊类型">-->
            <!--<el-select v-model="form.referralType" placeholder="转诊类型" :disabled="true">-->
            <!--<el-option v-for="(data,index) in REFERRAL_TYPE" :key="index" :label="data.name"-->
            <!--:value="data.name"></el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="4">-->
            <!--<el-form-item label="病人姓名">-->
            <!--<el-input v-model="form.patName" placeholder="病人姓名"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="3">-->
            <!--<el-form-item label="性别" label-width="40px">-->
            <!--<el-select v-model="form.sex" placeholder="性别">-->
            <!--<el-option v-for="(sex,index) in SEX" :key="index" :label="sex" :value="sex"></el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="3">-->
            <!--<el-form-item label="年龄" label-width="40px">-->
            <!--<el-input v-model="form.age" placeholder="年龄"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="5">-->
            <!--<el-form-item label="身份证号">-->
            <!--<el-input v-model="form.patIdcard" placeholder="身份证号"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="5">-->
            <!--<el-form-item label="电话号码">-->
            <!--<el-input v-model="form.patMobile" placeholder="电话号码"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</el-row>-->
            <!--<el-row>-->
            <!--<template v-if="this.form.referralType==='住院转诊'">-->
            <!--<el-col :span="4">-->
            <!--<el-form-item label="患者住院号" label-width="90px">-->
            <!--<el-select v-model="form.patInhosnoType" placeholder="门诊" :disabled="true">-->
            <!--<el-option value="门诊" label="门诊"></el-option>-->
            <!--<el-option value="住院" label="住院"></el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="2">-->
            <!--<el-form-item label="" label-width="5px">-->
            <!--<el-input v-model="form.patInhosno" placeholder="住院号"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="4">-->
            <!--<el-form-item label-width="200px">-->
            <!--<span slot="label" class="color_999">（若门诊病人，无需填写）</span>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</template>-->
            <!--<el-col :span="5">-->
            <!--<el-form-item label="其他联系方式" label-width="100px">-->
            <!--<el-input v-model="form.otherContactWay" placeholder=""></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="4" class="ml20">-->
            <!--<el-form-item label="医生电话">-->
            <!--<el-input v-model="form.docTelphone" placeholder=""></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="4" class="ml20">-->
            <!--<el-form-item label="职业" label-width="40px">-->
            <!--<el-input v-model="form.patJob" placeholder="职业"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</el-row>-->
            <!--<el-row>-->
            <!--<el-col :span="6">-->
            <!--<el-form-item label="家庭住址">-->
            <!--<el-cascader :value="areaArr" @change="areaChange" @active-item-change="activeItemChange"-->
            <!--:options="area"-->
            <!--:props="{label:'areaName',value:'id'}"-->
            <!--placeholder="请选择地区"></el-cascader>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="10">-->
            <!--<el-form-item label="" label-width="10px">-->
            <!--<el-input v-model="form.address" placeholder="请输入详细地址"></el-input>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</el-row>-->
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import hos_apply_title from "../../components/hos/hos-apply-title";
  import {systemService} from "../../lib/service/system";
  import {hosService} from "../../lib/service/hos";
  import {REFERRAL_TYPE, SEX} from "../../lib/config";
  import {getRandomHisPatInfo} from "../../lib/mock";
  import {isEmpty, pickByArray, pickByObject} from "../../lib/utils";
  import {referralFormMixin} from "../../lib/mixins/referral-form";
  import {getSexFromIdCardFilter} from "../../lib/filters";
  import {referralOrderCache} from "../../lib/cache/ReferralOrder";
  import {patineInfoRules} from '../../lib/hos/until'

  export default {
    name: "referral-base-form",
    components: {hos_apply_title},
    props: {
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        area: [], areaArr: [],
        SEX, REFERRAL_TYPE,
        form: {
          age: '',
          sex: '',
          // patInhosnoType: '',
          patName: '',
          patIdcard: '',
          patMobile: '',
          referralType: '',
          // patInhosno: '',
          otherContactWay: '',
          // docTelphone: '',
          areaCode: '',
          address: '',
          patJob: '',
          province: '',
          city: '',
          area: ''
        },
        cardId: "",//患者就诊卡号
        provinceList: [],//省
        cityList: [],//市
        areaList: [],//区
        referralOrder: null,//当前订单
        cardIdHos: '',//就诊卡查询医院
        cardIdHosList: [],
        patineInfoRules
      }
    },
    mixins: [referralFormMixin],
    async created() {
      const {meta, query} = this.$route;
      await this.queryHosList();
      await this.getAreaList();
      if (meta.type === 'apply') {
        this.setFormReferralType();//设置页面来源属性  住院 还是 门诊
        if (query.from && query.from === 'consultation') {
          this.form = {...this.form, ...referralOrderCache.get()};
          let areaArr = await systemService.getAllAreaCode(this.form.areaCode);
          this.resetArea(areaArr);
        }
      }
      //是否是再次申请
      if (query.again) {
        this.setAgainData();//设置缓存数据
        this.getPro();
      }
    },
    watch: {
      // value: {
      //   deep: true,
      //   async handler(newV) {
      //     this.form = {...newV};
      //     this.form.age = newV.patAge;
      //     this.form.sex = getSexFromIdCardFilter(newV.patIdcard);
      //     // let areaArr = await systemService.getAllAreaCode(this.form.areaCode);
      //     // this.resetArea(areaArr);
      //     this.setFormReferralType();
      //     await this.getAreaList();
      //     this.getPro();
      //   }
      // }
    },
    methods: {
      getForm() {
        let vail = true;
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            vail = false
            return false;
          }
        });
        //判断区域code
        if (this.form.area != "") {
          this.form.areaCode = this.form.area;
        } else if (this.form.city != "") {
          this.form.areaCode = this.form.city;
        } else {
          this.form.areaCode = this.form.province;
        }
        console.log('病人信息表单查询数据：');
        console.log(this.form);
        return {form: this.form, vail: vail};
      },

      async getDemoPat() {
        let pat = await getRandomHisPatInfo();
        this.form = Object.assign({}, this.form, pickByArray(pat, ['age', 'sex', 'docTelphone', 'otherContactWay']), pickByObject(pat, {
          patName: 'consulterName',
          patIdcard: 'consulterIdcard',
          patMobile: 'consulterMobile',
          patInhosno: 'consulterInhosno',
          areaCode: 'consulterAreaCode',
          address: 'consulterAddress',
          patJob: 'consulterJob'
        }));
        let areaArr = await systemService.getAllAreaCode(this.form.areaCode);
        this.resetArea(areaArr);
      },


      // async getAreaList() {
      //   const area = await systemService.areaList(null, 1);
      //   this.area = area.map(r => {
      //     return {areaName: r.areaName, id: r.id, children: []};
      //   });
      // },
      async resetArea(areaArr) {
        const {area} = this;
        if (isEmpty(area)) {
          setTimeout(this.resetArea, 200);
        } else {
          let level = 2, currList = this.area;
          while (level <= 3) {
            let arr = await systemService.areaList(areaArr[level - 2], level);
            let currArea = currList.find(r => r.id === areaArr[level - 2]);
            currArea.children = arr;
            currList = arr;
            level++;
          }
          this.areaArr = areaArr;
        }
      },
      async activeItemChange(val) {
        Log('val', val);
        let list = await systemService.areaList([...val].pop(), val.length + 1);
        let arr = this.area, curr = null;
        for (let a of val) {
          curr = arr.find(r => r.id === a);
          arr = curr.children;
        }
        if (list.length > 0) {
          curr.children = list.map(r => {
            return {areaName: r.areaName, id: r.id, children: val.length >= 2 ? undefined : []};
          });
        } else {
          delete curr.children;
        }
      }
      ,
      areaChange(val) {
        this.form.areaCode = [...val].pop();
      },
      //根据就诊卡查询信息的方法
      async search() {
        if (this.cardId == "") return this.$message.error('请输入就诊卡号。');
        if (this.cardIdHos == "") return this.$message.error('请选择就诊卡号所属医院。');
        const {code, list} = await hosService.searchByCard({
          orgid: this.cardIdHos,
          hosPatid: this.cardId,
          type: '1'
        })
        if (list.length != 0 && code == 0) {
          this.form.patIdcard = list[0].idcard || '';
          this.form.patMobile = list[0].mobileno || '';
          this.form.patName = list[0].patname || '';
          this.form.address = list[0].address || '';
          this.mathSexAndAge();
        } else {
          this.$message.error('未查询到相关信息。')
        }
      },
      //获取地区联动列表
      async getAreaList() {
        const obj = await hosService.getAllArea({});
        for (let i in obj) {
          this.provinceList.push(obj[i]);
        }
      },
      //下拉框事件
      getCityList(f) {
        const that = this;
        if (f == 1) {
          let city = this.provinceList.find(function (item) {
            return item.id == that.form.province
          })
          this.cityList = city.subSysArea;
          this.form.city = "";
          this.form.area = "";
          this.areaList = [];
        } else {
          let area = this.cityList.find(function (item) {
            return item.id == that.form.city
          })
          this.areaList = area.subSysArea;
          this.form.area = "";
        }
      },
      //根据身份证计算性别还有年龄
      mathSexAndAge() {
        console.log('form==>', this.form)
        let idCard = this.form.patIdcard;
        this.form.sex = parseInt(idCard.substr(16, 1)) % 2 == 1 ? 'M' : 'F';

        if (!/^\d{6}((?:19|20)((?:\d{2}(?:0[13578]|1[02])(?:0[1-9]|[12]\d|3[01]))|(?:\d{2}(?:0[13456789]|1[012])(?:0[1-9]|[12]\d|30))|(?:\d{2}02(?:0[1-9]|1\d|2[0-8]))|(?:(?:0[48]|[2468][048]|[13579][26])0229)))\d{2}(\d)[xX\d]$/.test(idCard)) {
          this.$message.error('身份证格式非法');
          return;
        }
        (RegExp.$1).substr(0, 4) + '-' + (RegExp.$1).substr(4, 2) + '-' + (RegExp.$1).substr(6, 2);
        console.log('RegExp.$1',RegExp.$1)
        let myDate = new Date();
        // this.form.age=date.getFullYear() - (RegExp.$1).substr(0,4);
        let year = myDate.getFullYear()
        let month = myDate.getMonth() + 1
        let longMonth = String(month).length > 1 ? month : '0' + String(month)
        let day = myDate.getDate()
        let date = String(longMonth) + String(day)//19960601
        let num = date > (RegExp.$1).substring(4, 8) ? 0 : 1
        this.form.age = year - (RegExp.$1).substring(0, 4) - num;
      },
      //获取省市
      getPro() {
        let nameArr = this.referralOrder.areaName.split(',');
        if (nameArr.length == 0 || nameArr == '') return
        let pro = this.provinceList.find(function (item) {
          return item.areaName == nameArr[0]
        });
        this.cityList = pro.subSysArea;
        this.form.province = pro.id;

        let ci = this.cityList.find(function (item) {
          return item.areaName == nameArr[1]
        });
        this.form.city = ci.id;
        this.areaList = ci.subSysArea;

        let ar = this.areaList.find(function (item) {
          return item.areaName == nameArr[2]
        });
        this.form.area = ar.id;
      },
      setAgainData() {
        const cache = this.$cache.get('referralOrderCache');
        this.referralOrder = {...pickByArray(cache, ['patName', 'patIdcard', 'patAge', 'patMobile', 'consulterMobile', 'otherContactWay', 'docTelphone', 'patJob', 'areaCode', 'address', 'areaName', 'patGender'])}
        this.form = Object.assign({}, this.form, this.referralOrder);
        this.form.sex = this.referralOrder.patGender;
        this.form.age = this.referralOrder.patAge
      },
      async queryHosList() {
        const {code, list = []} = await this.$http('smarthos.yygh.ApiPlatBaseService.areaHosList')
        this.cardIdHosList = list;
      }
    },
  }
</script>

<style scoped lang="scss">

</style>
